<template>
  <div class="indexBg">
    <div class="box" :class="{ 'is-visible': showBox }">
      <div class="endText">
        共用时：<span>{{ formattedTime }}</span>
      </div>
    </div>
    <div
      class="submit"
      :class="{ 'is-visible': showSubmit }"
      @click="finishAndNavigate"
    ></div>
  </div>
</template>
<script>
import sceneManager from "@/utils/sceneManager";
export default {
  name: "bookHotelIndex21",
  data() {
    return {
      currentPage: 21,
      totalPages: 21,
      isReturn: false,
      showQuestion: false,
      showPrompt: false,
      promptShown: false,
      showWarning: false,
      showGuidance: false,
      showBox: false,
      showSubmit: false,
      bgImage: require("@/assets/scene/bookHotel/bg21.jpg"),
      // promptImage: require("@/assets/scene/bookHotel/prompt22.png"),
      startTime: null,
      timer: null,
      lastInteractionTime: null,
      guidanceTimer: null,
      submitting: false,
      elapsedSeconds: 0,
      totalTime: 0,
    };
  },
  computed: {
    visiblePageNumbers() {
      // 计算当前显示的5个页码
      const start = Math.max(
        1,
        Math.min(this.currentPage - 2, this.totalPages - 4)
      );
      return Array.from({ length: 5 }, (_, i) => start + i).filter(
        (num) => num <= this.totalPages
      );
    },
    formattedTime() {
      const minutes = Math.floor(this.totalTime / 60);
      const seconds = this.totalTime % 60;
      const paddedSeconds = seconds < 10 ? `0${seconds}` : seconds;
      return `${minutes}分${paddedSeconds}秒`;
    },
  },
  created() {
    // 如果从 evaluation.vue 跳转过来，会存在全局开始时间
    const globalStart =
      typeof window !== "undefined" && window.__evaluationStartTimestamp
        ? window.__evaluationStartTimestamp
        : Date.now();

    this.startTime = globalStart; // 用全局时间作为起点;
    this.lastInteractionTime = Date.now();
    const storedTotal =
      typeof window !== "undefined" ? window.__evaluationTotalSeconds : null;
    const elapsed = Math.floor((Date.now() - this.startTime) / 1000);
    this.totalTime =
      typeof storedTotal === "number" && storedTotal >= 0
        ? storedTotal
        : elapsed;
    this.elapsedSeconds = this.totalTime;
    if (typeof window !== "undefined") {
      delete window.__evaluationTotalSeconds;
    }
  },
  mounted() {
    requestAnimationFrame(() => {
      this.showBox = true;
      setTimeout(() => {
        this.showSubmit = true;
      }, 500);
    });
  },
  beforeDestroy() {
    if (this.timer) clearInterval(this.timer);
    if (this.guidanceTimer) clearTimeout(this.guidanceTimer);
  },
  methods: {
    startTimer() {
      // ✅ 再启动定时器，保持每秒更新
      this.timer = setInterval(() => {
        this.elapsedSeconds = Math.floor((Date.now() - this.startTime) / 1000);
      }, 1000);
    },
    handlePressReturn(state) {
      this.isReturn = state;
    },
    goReturn() {
      this.$dialog
        .confirm({
          title: "提示",
          message: "是否退出本次测评？",
        })
        .then(() => {
          // on confirm
          this.$router.replace("/");
        })
        .catch(() => {
          // on cancel
        });
    },
    goToNextPage() {
      this.finishAndNavigate();
    },
    toggleQuestion() {
      this.showQuestion = !this.showQuestion;
      this.updateInteractionTime();
    },
    showPromptAnimation() {
      // 左滑显示prompt图片
      setTimeout(() => {
        this.showPrompt = true;
        this.promptShown = true;
        // 5秒后收回
        setTimeout(() => {
          this.showPrompt = false;
        }, 5000);
      }, 500);
    },

    showWrongClick() {
      this.updateInteractionTime();
      this.showWarning = true;
      this.playFailSound();
      setTimeout(() => {
        this.showWarning = false;
      }, 2000);
    },
    checkIfCorrect() {
      // 根据实际需求判断点击是否正确
      // 这里返回true作为示例，实际应该根据点击位置或其他条件判断
      return true;
    },
    playSuccessSound() {
      try {
        const audio = new Audio(require("@/assets/music/success.mp3"));
        audio.play().catch((e) => console.log("Audio play failed:", e));
      } catch (e) {
        console.log("Success sound not found or failed:", e);
      }
    },
    playFailSound() {
      try {
        const audio = new Audio(require("@/assets/music/fail.mp3"));
        audio.play().catch((e) => console.log("Audio play failed:", e));
      } catch (e) {
        console.log("Fail sound not found or failed:", e);
      }
    },
    async finishAndNavigate() {
      if (this.submitting) return;
      this.submitting = true;
      try {
        const result = await sceneManager.submitResults();
        if (result) {
          this.$router.replace({
            path: "/result",
            query: result,
          });
        } else {
          this.$router.replace("/evaluation");
        }
      } catch (error) {
        console.error("提交场景题失败：", error);
        this.$router.replace("/evaluation");
      }
    },
    updateInteractionTime() {
      this.lastInteractionTime = Date.now();
      if (this.showGuidance) {
        this.hideGuidance();
      }
      this.startGuidanceTimer();
    },
    hideGuidance() {
      // this.showGuidance = false
    },
  },
};
</script>
<style scoped lang="less">
.indexBg {
  width: 100%;
  height: 100vh;
  background-image: url("@/assets/end/bg.png");
  background-size: 100% 100%;
  background-position: center;
  background-repeat: no-repeat;
  position: relative;
  overflow: hidden;
}
.box {
  position: absolute;
  top: 50px;
  left: 50%;
  z-index: 999;
  width: 687px;
  height: 671px;
  opacity: 0;
  transform: translateX(-50%) scale(0.6);
  transition: transform 0.45s ease-out, opacity 0.45s ease-out;
  background: url("@/assets/end/endImg.png") no-repeat center / 100% 100%;
  &.is-visible {
    opacity: 1;
    transform: translateX(-50%) scale(1);
  }
  .endText {
    position: absolute;
    top: 550px;
    left: 50%;
    transform: translateX(-50%);
    font-size: 46px;
    color: #000000;
    width: 100%;
    text-align: center;
    span {
      font-weight: bold;
      color: #ee413c;
    }
  }
}
.submit {
  position: absolute;
  top: 850px;
  left: 50%;
  z-index: 999;
  width: 400px;
  height: 111px;
  opacity: 0;
  transform: translateX(-50%);
  transition: opacity 0.3s ease;
  background: url("@/assets/end/submit.png") no-repeat center / 100% 100%;
  cursor: pointer;
  pointer-events: none;
  &.is-visible {
    opacity: 1;
    pointer-events: auto;
  }
}
</style>
